import http from "../http/http-config";
import { IvaConditions } from "../models/IvaConditions";

export default new class IvaConditionsService {
    getIvaConditionsList(): Promise<IvaConditions[]> {
        return http.get<IvaConditions[]>("IvaConditions", {
            params: {
                companyId: 1
            }
        }).then(response => response.data)
    }
}

